
export const shouldShowJiraWidget = (opts: { isBrandingEnabled: boolean, isExternalUser: boolean; }) => {
  return !opts.isBrandingEnabled || !opts.isExternalUser;
};